import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en.json';
import es from './es.json';

/*
|------------------------------------------------------------------------------
| NACIS i18n
|------------------------------------------------------------------------------
| Supported locales: en (default), es. Detection order: explicit
| localStorage choice → browser Accept-Language. Persisted to `nacis.locale`.
|
| Add new locales: drop the JSON file in this dir, register it in `resources`
| below, and add a row to LANGUAGES in LanguageSwitcher.jsx. Translation
| keys are organised by surface — see en.json for the canonical structure.
|------------------------------------------------------------------------------
*/

export const LOCALE_STORAGE_KEY = 'nacis.locale';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    nonExplicitSupportedLngs: true,         // 'es-MX' matches 'es'
    interpolation: { escapeValue: false },  // React already escapes
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: LOCALE_STORAGE_KEY,
    },
    returnNull: false,
  });

// Keep <html lang> in sync so screen readers + search engines see the
// active locale, and per-locale CSS (e.g. typographic rules) can hook in.
function syncHtmlLang(lng) {
  if (typeof document !== 'undefined' && lng) {
    document.documentElement.lang = lng.split('-')[0];
  }
}
syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
